import type { ListCharterPromotionPricingInventoryParams } from '~/types/charterPromotionPricingInventory';

export const charterHundredDollarPromotionQueryKeys = {
  all: ['flights-charter', 'hundred-dollar-promotion'] as const,
  lists: () => [...charterHundredDollarPromotionQueryKeys.all, 'list'] as const,
  list: (filters?: ListCharterPromotionPricingInventoryParams) =>
    [...charterHundredDollarPromotionQueryKeys.lists(), filters] as const,
};
